import React, { Component } from 'react';
import common from './../../../common';

class EOT extends Component {
  handleClick = () => {
    const url = 'https://www.uefa.com/';
    window.open(url);
  };

  onClickClose = (guid) => {
    let objCookie = common.getLocalStorage('isCardDismissed');
    if (!objCookie) {
      objCookie = {};
    }
    objCookie[guid] = true;
    common.setLocalStorage('isCardDismissed', objCookie);
    this.props.updateCardDismissedStatus(true);
  };

  render() {
    let trans = this.props.trans;
    let guid = common.getGUID();
    let isCardClosed = this.props.isCardClosed;
    if (!isCardClosed) {
      return (
        <div className='si-card si-card__eot'>
          <div className='si-card__eot-ct'>
            <div
            className='si-close-card'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              this.onClickClose(guid);
            }}></div>
            <div className='si-mt-text-title'>
              {trans.eotCardTitle
                ? trans.eotCardTitle
                : 'Thanks for playing UEFA Champions League Fantasy this season'}
            </div>
            <div className='si-text-descp'>
              {trans.eotCardDesc1
                ? trans.eotCardDesc1
                : `We want to thank you for taking part. We've summarised all your points, round-by-round below and you can also see the top performing fantasy team of the season.`}
            </div>
            <div className='si-text-descp'>
              {trans.eotCardDesc2Part1
                ? trans.eotCardDesc2Part1
                : `We'll be back next year, but in the mean time why not spare 2 mins
                and `}{' '}
              <a href=''>
                {trans.eotCardDesc2Link
                  ? trans.eotCardDesc2Link
                  : `provide us feedback`}
              </a>{' '}
              {trans.eotCardDesc2Part2
                ? trans.eotCardDesc2Part2
                : `on what you thought of this
                  years game?`}
            </div>
            <div className='button-block'>
              <div
                className='si-btn btn-lg'
                onClick={() => {
                  this.handleClick();
                }}>
                {trans.eotCardButton
                  ? trans.eotCardButton
                  : `Optional button with an external link`}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default EOT;



// WEBPACK FOOTER //
// ./src/components/home/cards/EOT.js